import classNames from "components/ui/classNames";
import { FormattedMessage } from "react-intl";

interface AnnualReturnColumnProps {
  annualReturn: number | null;
}
export default function AnnualReturnColumn({ annualReturn }: AnnualReturnColumnProps) {
  if (!annualReturn) {
    return null;
  }

  const percentageFormatter = new Intl.NumberFormat("en-US", {
    style: "percent",
    notation: Math.abs(annualReturn) > 1000 ? "compact" : "standard",
    maximumSignificantDigits: 2,
  });

  return (
    <div className="flex flex-col">
      <strong
        className={classNames("text-xl font-bold text-slate-600 ", {
          "text-emerald-600 dark:text-emerald-400": annualReturn > 0,
          "text-slate-600 dark:text-slate-400": annualReturn === 0,
          "text-red-600 dark:text-red-400": annualReturn < 0,
        })}
      >
        {annualReturn > 0 ? "+" : ""}
        {percentageFormatter.format(annualReturn)}
      </strong>
      <p className="text-xs font-medium text-gray-500 dark:text-slate-400">
        <FormattedMessage defaultMessage="Retorno Anual" id="Z8+BV4" />
      </p>
    </div>
  );
}
